import { useCallback } from 'react'
import { t } from '@lingui/macro'
import { useLingui } from '@lingui/react'
import { useSnackbar } from 'notistack'
import { CreateShiftExceptionParams } from '@/core/api/planning'
import { useCreateShiftExceptionMutation } from '@/core/services/planning'
import { getApiErrorMessage } from '@/utils/errors'

export function useCreateShiftException() {
  useLingui()
  const { enqueueSnackbar } = useSnackbar()

  const [createShiftExceptionMutation, { isLoading }] = useCreateShiftExceptionMutation()

  const createShiftException = useCallback(async (params: CreateShiftExceptionParams) => {
    try {
      await createShiftExceptionMutation(params).unwrap()
      enqueueSnackbar(t`Shift has been deleted successfully`, { variant: 'success' })
    } catch (error) {
      enqueueSnackbar(getApiErrorMessage(error), { variant: 'error' })
    }
  }, [])

  return [createShiftException, isLoading] as const
}
